const Address = require('./Address');

class Partner {
  constructor() {
    this.init();
  }

  init() {
    this.partner_id = undefined;
    this.legup_list_id = undefined;
    this.name = '';
    this.email = '';
    this.phone_number = undefined;
    this.address = new Address();
    this.logo_url = undefined;
  }

  copy() {
    const cp = new Partner();

    cp.partner_id = this.partner_id;
    cp.legup_list_id = this.legup_list_id;
    cp.name = this.name;
    cp.email = this.email;
    cp.contact = this.contact;
    cp.phone_number = this.phone_number;
    cp.address = this.address;
    cp.logo_url = this.logo_url;
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.partner_id = obj.partner_id ? obj.partner_id.toString() : undefined;
      this.legup_list_id = obj.legup_list_id ? obj.legup_list_id.toString() : undefined;
      this.name = obj.name ? obj.name : '';
      this.email = obj.email? obj.email: '';
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});
      this.logo_url = obj.logo_url ? obj.logo_url : undefined;
    }
  }

  toString() {
    let result = this.name;
    const address = this.address.toString();

    if (this.partner_id) {
      result = (result.length) ? `${result} (${this.partner_id})` : `${this.partner_id}`;
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.partner_id;
  }

  setId(partner_id) {
    this.partner_id = partner_id ? partner_id.toString() : undefined;
  }

  getLegupListId() {
    return this.legup_list_id;
  }

  setLegupListId(legup_list_id) {
    this.legup_list_id = legup_list_id ? legup_list_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }
  
  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getLogoUrl() {
    return this.logo_url;
  }

  setLogoUrl(logo_url) {
    this.logo_url = logo_url;
  }
}

module.exports = Partner;
